import { cn } from '@lib/cn'
import { FC, HTMLAttributes } from 'react'
import { Container } from './Layout'

interface CenteredContentProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

export const CenteredContent: FC<CenteredContentProps> = ({ children, className, ...props }) => {
  return (
    <Container className="grid lg:grid-cols-3 lg:gap-6">
      <div
        className={cn(
          'lg:col-start-2',
          'lg:col-end-3',

          className,
        )}
        {...props}
      >
        {children}
      </div>
    </Container>
  )
}
